<template>
	<div class="incenters">
		<div style="">
			<!--  -->
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<!--   -->
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px"
				:useAutoOptional="false" :optional="handleList.length !== 1" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<!--  -->
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<!--   -->
			<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" title="启用" fontSize="14px" @btnclick="Active"
				:src="require('@/assets/icon/qy.png')">
			</Commonbtn>
			<!--   -->
			<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" title="停用" fontSize="14px" @btnclick="DeActive"
				:src="require('@/assets/icon/icon-stop.png')">
			</Commonbtn>
			<CommonbtnUpLoad backgroundColor="#FFF" title="导入" fontSize="14px" @getFile="InvoiceImport"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="CRExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<!-- <CommonbtnUpLoad backgroundColor="#FFF" types="multiple" title="上传照片" fontSize="14px"
				@getFiles="UploadPhotos" :src="require('@/assets/icon/daoc.png')">
			</CommonbtnUpLoad> -->
			<a class="Dowload" style="" @click="DsphfDowload">下载产品货值模版</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick" colnum=522
				:tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="640px" title="新增商品货值" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist :key="index" ref="ProductAddref" :inputflag="item.inputflag" :radio="item.radio"
						:selcoms="item.selcoms" :widths="item.widths" :loading="loading"
						@remoteMethodtows="remoteMethodtows" @remoteMethodtowPer="remoteMethodtowPer"
						@remoteMethodtowHB="remoteMethodtowHB" :options="item.options" :btx="item.btx"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<DialogFrom width="640px" title="修改商品货值" :loading="loading" :dialogVisible="dialogVisiblesedit"
			@cancel="canceledit" @dialogOK="dialogOKedit">
			<div class="from">
				<template v-for="(item , index) of fromdataedit">
					<Commondropdownlist ref="ProductEditref" :inputflag="item.inputflag" :radio="item.radio"
						:key="index" :widths="item.widths" :options="item.options" @remoteMethodtows="remoteMethodtows"
						@remoteMethodtowPer="remoteMethodtowPer" @remoteMethodtowHB="remoteMethodtowHB"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该业务员医院关系吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要启用这条档案吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivateDe" @cancel="canceldeactivateDe"
			@dialogOK="dialogOKdeactivateDe" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条档案吗？</span>
		</Dialog>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Commonpictureswitching :show="show" @hidefn="hidefn" :picImages="picImages"></Commonpictureswitching>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import Commonpictureswitching from '../../../../components/common-pictureswitching.vue'
	import CommonUploadEnclosure from '../../../../components/common-upload-Enclosure.vue'
	import {
		InvStandardCostAdd,
		InvStandardCostInfo,
		InvStandardCostEdit,
		CusRelationProviderGetInvoicePic,
		InvStandardCostDelete,
		InvStandardCostActive,
		InvStandardCostDeActive,
		InvStandardCostImport,
		CusRelationProviderUploadSalesInvListPic,
		InvStandardCostDownloadTemplet,
		CusRelationProviderUploadSalesInvListByEdit,
		HospitalGetHospitalType,
		InventoryClassList,
		CustomerList,
		HospitalList
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad,
			Commonpictureswitching,
			CommonUploadEnclosure
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisibledeactivateDe: false,
				rowboo: false,
				dialogVisiblesdrjg: false,
				cityArr: [], //市
				rightboo: false,
				dwonleft: false,
				loading: false,
				show: false,
				title: "结果",
				ID: '',
				ptype: '',
				HPid: '',
				HospHPid: '',
				InvClassCode: '',
				InvClassCodeName: '',
				HPidName: '',
				HospHPidName: '',
				UploadUrl: [],
				fromdataadd: [],
				fromdataedit: [],
				handleList: [],
				tableDatadrjg: [],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50,

					},
					{
						prop: 'InvAddCode',
						label: '产品代码',
						columnwidth: 160
					},
					{
						prop: 'InvName',
						label: '产品名称',
						columnwidth: 150
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 150
					},
					{
						prop: 'LEVEL2',
						label: 'LEVEL2',
						columnwidth: 150
					},
					{
						prop: 'LEVEL3',
						label: 'LEVEL3',
						columnwidth: 150
					},
					{
						prop: 'ValiDate',
						label: '启效日期',
						columnwidth: 130
					},
					{
						prop: 'StandardCost',
						label: '标准货值',
						columnwidth: 130
					},
					{
						prop: 'Enabled',
						label: '是否启用',
						columnwidth: 80
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 100
					},
					{
						prop: 'CreateTime',
						label: '创建时间',
						columnwidth: 120
					},
					{
						prop: 'UpdaterName',
						label: '修改人',
						columnwidth: 100
					},
					{
						prop: 'UpdateTime',
						label: '修改时间',
						columnwidth: 120
					},
					{
						prop: 'ActivorName',
						label: '停启用人',
						columnwidth: 100
					},
					{
						prop: 'ActiveTime',
						label: '停启用时间',
						columnwidth: 120
					},
				],
				picImages: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
			}
		},
		created() {

		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 159) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 58) {
								this.qus = items.Nodes
							}
						})
					}
					// console.log(this.qus, 'this.qus');
				})
				//console.log(this.qus);
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						}
					})
				}
			},
			// async cusRelationProviderGetInvoicePic(id) {
			//   let {
			//     code,
			//     data
			//   } = await CusRelationProviderGetInvoicePic({
			//     ID: id
			//   })
			//   if (code == 0) {
			//     this.picImages = data.picImages
			//   }
			// },
			// cz(ID) {
			//   this.cusRelationProviderGetInvoicePic(ID)
			//   this.show = true
			// },
			hidefn() {
				this.show = false
			},
			async remoteCustomer(val) {
				let {
					data,
					code
				} = await CustomerList({
					CusName: val,

				})
				if (code == 0) {
					this.InvClassCode = data.data[0].CusCode
				}
			},
			// 二级经销商下拉
			async remoteMethodtowPer(query) {
				this.loading = true
				let {
					data,
					code
				} = await CustomerList({
					CusName: query,

				})
				if (code == 0) {
					this.fromdataadd[1].options = []
					this.fromdataedit[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName
						}
						this.fromdataadd[1].options.push(obj)
						this.fromdataedit[1].options.push(obj)
					})
					this.loading = false
				}
			},
			async hospitalGetHospitalType() {
				let {
					data,
					code
				} = await HospitalGetHospitalType({})
				if (code == 0) {
					this.fromdataadd[2].options = []
					this.fromdataedit[2].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Name,
							value: item.Name
						}
						this.fromdataadd[2].options.push(obj)
						this.fromdataedit[2].options.push(obj)
					})
				}
			},
			// 详情
			async invStandardCostInfo() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载详情中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await InvStandardCostInfo({
					ID: this.ID
				})
				if (code == 0) {
					// this.fromdataedit[0].inputdata = data.data.InvCode
					this.fromdataedit[1].inputdata = data.data.InvAddCode
					this.fromdataedit[2].inputdata = data.data.StandardCost
					this.fromdataedit[3].inputdata = data.data.ValiDate
					loading.close();
					this.dialogVisiblesedit = true
				}
				loading.close();
			},
			// 修改
			async invStandardCostEdit() {
				const loading = this.$loading({
					lock: true,
					text: '修改中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await InvStandardCostEdit({
					ID: this.ID,
					// InvCode: this.$refs.ProductEditref[0].modelvalue,
					InvAddCode: this.$refs.ProductEditref[1].modelvalue,
					StandardCost: this.$refs.ProductEditref[2].modelvalue,
					ValiDate: this.$refs.ProductEditref[3].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.rowboo == false
					loading.close();
					this.dialogVisiblesedit = false
					this.$parent.invStandardCostList()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close();
			},
			// 新增
			async invStandardCostAdd() {
				const loading = this.$loading({
					lock: true,
					text: '正在新增中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await InvStandardCostAdd({
					// InvCode: this.$refs.ProductAddref[0].modelvalue,
					InvAddCode: this.$refs.ProductAddref[1].modelvalue,
					StandardCost: this.$refs.ProductAddref[2].modelvalue,
					ValiDate: this.$refs.ProductAddref[3].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.rowboo == false
					this.handleList.length = 0
					this.$parent.invStandardCostList()
					this.dialogVisibles = false
					this.$refs.ProductAddref.map((item, index) => {
						item.modelvalue = ""
					})
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close();
			},
			// 编辑上传照片
			async cusRelationProviderUploadSalesInvListByEdit(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					for (var i = 0; i < file.length; i++) {
						formData.append("files", file[i]);
					}
					let res = await CusRelationProviderUploadSalesInvListByEdit(formData)
					if (res.code == 0) {
						this.UploadUrl = res.data
						this.$message({
							type: 'success',
							message: res.message
						})
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			getFileDsphImg(file) {
				this.cusRelationProviderUploadSalesInvListByEdit(file)
			},
			// 删除
			async invStandardCostDelete() {
				let arr = []
				this.handleList.map((item, index) => {
					arr.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await InvStandardCostDelete({
					IDs: arr
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功"
					})
					this.$parent.invStandardCostList()
					this.rowboo == false
					// this.handleList.length = 0
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					})
				} else if (code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "删除结果"
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			// 启用
			async invStandardCostActive() {
				let arr = []
				this.handleList.map((item, index) => {
					arr.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await InvStandardCostActive({
					IDs: arr
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "启用成功"
					})
					this.$parent.invStandardCostList()
					this.rowboo == false
					// this.handleList.length = 0
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					})
				} else if (code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "启用结果"
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},

			// 停用
			async invStandardCostDeActive() {
				let arr = []
				this.handleList.map((item, index) => {
					arr.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await InvStandardCostDeActive({
					IDs: arr
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "停用成功"
					})
					this.$parent.invStandardCostList()
					this.rowboo == false
					// this.handleList.length = 0
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message
					})
				} else if (code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "停用结果"
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},

			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.fromdataadd[0].options = []
					this.fromdataedit[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.fromdataedit[0].options.push(obj)
						this.fromdataadd[0].options.push(obj)
					})
				}
			},
			// 导入
			async invStandardCostImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '导入中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await InvStandardCostImport(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					this.$parent.invStandardCostList()
					loading.close();
				}
			},
			InvoiceImport(file) {
				this.invStandardCostImport(file)
			},
			async invStandardCostDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await InvStandardCostDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			DsphfDowload() {
				this.invStandardCostDownloadTemplet()
			},
			async hospital(val) {
				let {
					code,
					data
				} = await HospitalList({
					IsProvider: 1,
					HPName: val,
				})
				if (code == 0) {
					this.HPid = data.data[0].HPID
				}
			},
			async hospitalHP(val) {
				let {
					code,
					data
				} = await HospitalList({
					HosType: "医院",
					HPName: val,
				})
				if (code == 0) {
					this.HospHPid = data.data[0].HPID
				}
			},
			async remoteMethodtowHB(query) {
				this.loading = true
				let {
					code,
					data
				} = await HospitalList({
					IsProvider: 1,
					HPName: query,
				})
				if (code == 0) {
					this.fromdataadd[3].options = []
					this.fromdataedit[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.fromdataadd[3].options.push(obj)
						this.fromdataedit[3].options.push(obj)
					})
					this.loading = false
				}
			},
			// 医院下拉
			async remoteMethodtows(query) {
				this.loading = true
				let {
					code,
					data
				} = await HospitalList({
					HosType: "医院",
					HPName: query
				})
				if (code == 0) {
					this.fromdataadd[4].options = []
					this.fromdataedit[4].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.fromdataadd[4].options.push(obj)
						this.fromdataedit[4].options.push(obj)
					})
					this.loading = false
				}
			},
			CRExport() {
				this.$emit('CRExport')
			},
			// 上传照片(多选)
			async UploadPhotos(file) {
				if (this.rowboo == true) {
					const loading = this.$loading({
						lock: true,
						text: '正在上传...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formdata = new FormData()
					for (var i = 0; i < file.length; i++) {
						formdata.append("files", file[i]);
					}
					let {
						data,
						code,
						message
					} = await CusRelationProviderUploadSalesInvListPic(formdata, this.ID)
					if (code == 0) {
						this.$message({
							type: 'success',
							message: message
						});
						loading.close();
						// this.rowboo = false
						this.$parent.cusRelationProviderList()
						return
					} else if (code == 101) {
						this.$message({
							type: 'warning',
							message: message
						});
						loading.close();
						return
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = data
						this.title = "上传结果"
						this.$message({
							type: 'error',
							message: message
						});
						loading.close();
					}
				}

				this.$message({
					type: "error",
					message: "请选择要操作的数据！"
				})

			},
			onRowClick(val) {
				this.ID = val.ID
				this.rowboo = true
				//console.log('val', val)
			},
			adduser() {
				this.dialogVisibles = true
				this.hospitalGetHospitalType()
				this.inventoryClassList()
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.invStandardCostAdd()

			},
			update() {
				if (this.handleList.length === 1) {
					this.ID = this.handleList[0].ID
					this.rowboo = true
					this.invStandardCostInfo()
					// this.hospitalGetHospitalType()
					// this.inventoryClassList()
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});
			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.invStandardCostEdit()

			},
			del() {
				if (this.handleList.length >= 1) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据(多选)！'
				});

			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.invStandardCostDelete()
				this.dialogVisibledel = false
			},
			Active() {
				if (this.handleList.length >= 1) {
					this.dialogVisibledeactivate = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要启用的数据(多选)！'
				});
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.invStandardCostActive()
				this.dialogVisibledeactivate = false
			},

			downs(index) {
				// //console.log("index", index)
				if (index == 0) {
					this.dialogVisiblesU8 = true
				}
				if (index == 1) {
					this.dialogVisiblesU8d = true
				}
			},
			DeActive() {
				if (this.handleList.length >= 1) {
					this.dialogVisibledeactivateDe = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要停用的数据(多选)！'
				});
			},
			canceldeactivateDe() {
				this.dialogVisibledeactivateDe = false
			},
			dialogOKdeactivateDe() {
				this.invStandardCostDeActive()
				this.dialogVisibledeactivateDe = false
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			handleSelectionChange(val) {
				this.handleList = val
				if (val.length === 1) {
					this.ID = val[0].ID
					this.rowboo = true
					return
				}
				this.rowboo = false
				if (val.length === 0) {
					this.ID = ''
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>
